import React from 'react';
import PropTypes from 'prop-types';
import { CaretDownFilled, CaretLeftFilled, CaretRightFilled, CaretUpFilled, LeftOutlined, DownOutlined, UpOutlined, RightOutlined } from '@ant-design/icons';
import './styles.less';
import classNames from 'classnames';

const CaretIcon = ( { direction, className } ) => {
    const caretMap = {
        up: <>
            <UpOutlined className={ classNames( 'line', 'caret-icon', className ) } />
            <CaretUpFilled className={ classNames( 'full', 'caret-icon', className ) } />
        </>,
        down: <>
            <DownOutlined className={ classNames( 'line', 'caret-icon', className ) } />
            <CaretDownFilled className={ classNames( 'full', 'caret-icon', className ) } />
        </>,
        left: <>
            <LeftOutlined className={ classNames( 'line', 'caret-icon', className ) } />
            <CaretLeftFilled className={ classNames( 'full', 'caret-icon', className ) } />
        </>,
        right: <>
            <RightOutlined className={ classNames( 'line', 'caret-icon', className ) } />
            <CaretRightFilled className={ classNames( 'full', 'caret-icon', className ) } />
        </>,
    };
    
    return caretMap[ direction ];
};

CaretIcon.propTypes = {
    direction: PropTypes.oneOf( [ 'down', 'right', 'up', 'left' ] ).isRequired,
    className: PropTypes.string,
};

CaretIcon.defaultValues = {
    className: '',
};

export default CaretIcon;